/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesAuthAuthenticateFromGameResponseConnectedDataFromJSON, FxIdWebFeaturesAuthAuthenticateFromGameResponseConnectedDataToJSON, } from './FxIdWebFeaturesAuthAuthenticateFromGameResponseConnectedData';
import { FxIdWebFeaturesAuthAuthenticateFromGameResponseNotConnectedDataFromJSON, FxIdWebFeaturesAuthAuthenticateFromGameResponseNotConnectedDataToJSON, } from './FxIdWebFeaturesAuthAuthenticateFromGameResponseNotConnectedData';
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromGameResponse interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromGameResponse(value) {
    if (!('IsConnected' in value) || value['IsConnected'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateFromGameResponseFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromGameResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromGameResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'IsConnected': json['IsConnected'],
        'ConnectedData': json['ConnectedData'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateFromGameResponseConnectedDataFromJSON(json['ConnectedData']),
        'NotConnectedData': json['NotConnectedData'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateFromGameResponseNotConnectedDataFromJSON(json['NotConnectedData']),
    };
}
export function FxIdWebFeaturesAuthAuthenticateFromGameResponseToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromGameResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromGameResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'IsConnected': value['IsConnected'],
        'ConnectedData': FxIdWebFeaturesAuthAuthenticateFromGameResponseConnectedDataToJSON(value['ConnectedData']),
        'NotConnectedData': FxIdWebFeaturesAuthAuthenticateFromGameResponseNotConnectedDataToJSON(value['NotConnectedData']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromGameResponse.js.map